import { For } from "solid-js";
import type { Utterance } from "../types/utterance";
import { PanelHeader } from "./PanelHeader";
import { LanguageBadge } from "./LanguageBadge";
const colours = [
  "bg-indigo-100 border border-indigo-500 text-indigo-900",
  "bg-blue-50   border border-blue-400   text-blue-900",
  "bg-slate-50  border border-slate-400  text-slate-900",
  "bg-teal-50   border border-teal-400   text-teal-900",
  "bg-amber-100 border border-amber-500 text-amber-900",
];
export default function TranslationPanel(props: {
  utterances: Utterance[];
  langLabel: string; // e.g. "English (US)"
}) {
  const bubbles = () => props.utterances.filter((u) => u.translation); // only translated lines

  return (
    <div class="card">
      <div class="flex items-center gap-2 mb-2">
        <PanelHeader title="Transcript" />
        <LanguageBadge label={`${props.langLabel} · translation`} />
      </div>
      <div class="space-y-3">
        <For each={bubbles()}>
          {(u) => {
            const side = u.speaker % 2 ? "mr-auto" : "ml-auto";
            const clr = colours[u.speaker % colours.length];
            const labelMap: Record<number, string> = {
              1: "Party 1",
              2: "Party 2",
            };
            const label = labelMap[u.speaker] ?? `Speaker ${u.speaker}`;
            return (
              <p class={`max-w-[80%] ${clr} rounded-xl px-3 py-1 ${side}`}>
                <span class="text-xs opacity-70 mr-1">{label}</span>
                {u.translation}
              </p>
            );
          }}
        </For>
      </div>
    </div>
  );
}
